import Swiper from "swiper";
import { A11y, Navigation } from "swiper/modules";
import "@/styles/components/slider.css";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-component-related-posts]").forEach((el) => {
    const container = el.querySelector(".swiper");

    new Swiper(container, {
      modules: [A11y, Navigation],
      slidesPerView: 1,
      speed: 750,
      spaceBetween: 24,
      watchSlidesProgress: true,
      navigation: {
        nextEl: el.querySelector(".slider-button-next"),
        prevEl: el.querySelector(".slider-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: 2.1,
          slidesPerGroup: 2,
          spaceBetween: 24,
        },
        1024: {
          slidesPerView: 2.8,
          slidesPerGroup: 2,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 3.3,
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
        1536: {
          slidesPerView: 4.1,
          slidesPerGroup: 3,
          spaceBetween: 24,
        },
      },
    });
  });
});
